import { Box, FormControl, MenuItem, Select, styled } from '@mui/material';
import React from 'react';

export type DropdownProps = {
  label: string;
  options: Array<{ name: string; id: string; disabled?: boolean }>;
  id: string;
  handleChange: (val: string) => void;
  defaultText?: string;
};

const StyledWrapperComponent = styled('div')({
  color: '#4D4F53',
  padding: 4,
  borderRadius: 4,
  justifyContent: 'center',
});

const customScrollbar = {
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: 6,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    borderRadius: 2,
  },
};

export const Dropdown = (props: DropdownProps) => {
  const { label, options, handleChange, id, defaultText } = props;

  const optionItems = options.map(item => (
    <MenuItem
      key={item.id}
      value={item.id}
      disabled={item.disabled}
      sx={{ fontSize: 'inherit' }}
    >
      {item.name}
    </MenuItem>
  ));

  return (
    <StyledWrapperComponent>
      <FormControl
        fullWidth
        sx={{ display: 'flex', flexDirection: 'row' }}
        size="small"
      >
        <Box
          component="label"
          sx={{
            paddingRight: 2,
            alignContent: 'center',
            minWidth: 60,
            textAlign: 'right',
          }}
        >
          {label}
          {':'}
        </Box>
        <Select
          sx={{
            minWidth: 180,
            maxWidth: 180,
            fontSize: 'inherit',
            fontWeight: 600,
          }}
          displayEmpty
          inputProps={{
            'aria-label': label + 'dropdown',
            'aria-roledescription': 'dropdown',
          }}
          value={id}
          onChange={event => {
            handleChange(event.target.value);
          }}
          id={label}
          MenuProps={{
            PaperProps: {
              sx: customScrollbar,
            },
            disableScrollLock: true,
          }}
        >
          {defaultText ? (
            <MenuItem value="" sx={{ fontSize: 'inherit' }}>
              <em>{defaultText}</em>
            </MenuItem>
          ) : null}
          {optionItems}
        </Select>
      </FormControl>
    </StyledWrapperComponent>
  );
};
